<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Gl_backbutton />
                Оценочные ведомости
            </div>
            <div class="content-inner">
                <div class="btn_add" @click="$router.push('/marking_list/'+id+'/new')">Новая оценочная ведомость</div>
                <table>
                    <tr>
                        <th>Наименование оценочной ведомости</th>
                        <th>Корпоративный стандарт</th>
                        <th>Дата создания</th>
                        <th></th>
                    </tr>
                    <tr v-for="mk_list in marking_lists" :key="mk_list.id">
                        <td>{{mk_list.name}}</td>
                        <td>{{mk_list.corpstandart_name}}</td>
                        <td>{{mk_list.created_at}}</td>
                        <td>
                            <div class="btn_for_table buttons_inline" @click="$router.push('/marking_list/show/'+mk_list.id)" >Просмотр</div>
                            <div class="btn_for_table_delete buttons_inline" @click="delete_user(user.id)">Удалить</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Markinglist',
    props: ['id'],
    components: {
        Success, Error
    },
    mixins: [
        require('../../mixins/markinglist/markinglistMixins.vue')
    ],
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            marking_lists: {}
        }
    },
    created() {
        this.list(this.id)
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>